<template>
  <ListItem component="button" type="button" @click="$emit('click', 'shop')">
    <ListItemAction>
      <ShopIcon size="1.5rem" />
    </ListItemAction>
    <ListItemContent>
      <ListItemTitle>Shop</ListItemTitle>
      <ListItemSubtitle wrap
        >Shop your latest products and collections.</ListItemSubtitle
      >
    </ListItemContent>
  </ListItem>
</template>

<script>
import {
  ListItem,
  ListItemAction,
  ListItemContent,
  ListItemSubtitle,
  ListItemTitle,
  ShopIcon,
} from '@campsite-bio/component-lib';

export default {
  components: {
    ListItem,
    ListItemAction,
    ListItemContent,
    ListItemSubtitle,
    ListItemTitle,
    ShopIcon,
  },
};
</script>

<style lang="scss" scoped></style>
